var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.7915C6.325 4.7915 6.04167 4.50817 6.04167 4.1665V1.6665C6.04167 1.32484 6.325 1.0415 6.66667 1.0415C7.00833 1.0415 7.29167 1.32484 7.29167 1.6665V4.1665C7.29167 4.50817 7.00833 4.7915 6.66667 4.7915Z",
    fill: "#026C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.7915C12.9917 4.7915 12.7083 4.50817 12.7083 4.1665V1.6665C12.7083 1.32484 12.9917 1.0415 13.3333 1.0415C13.675 1.0415 13.9583 1.32484 13.9583 1.6665V4.1665C13.9583 4.50817 13.675 4.7915 13.3333 4.7915Z",
    fill: "#026C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.9582H6.66667C3.625 18.9582 1.875 17.2082 1.875 14.1665V7.08317C1.875 4.0415 3.625 2.2915 6.66667 2.2915H13.3333C16.375 2.2915 18.125 4.0415 18.125 7.08317V14.1665C18.125 17.2082 16.375 18.9582 13.3333 18.9582ZM6.66667 3.5415C4.28333 3.5415 3.125 4.69984 3.125 7.08317V14.1665C3.125 16.5498 4.28333 17.7082 6.66667 17.7082H13.3333C15.7167 17.7082 16.875 16.5498 16.875 14.1665V7.08317C16.875 4.69984 15.7167 3.5415 13.3333 3.5415H6.66667Z",
    fill: "#026C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.7915H6.66667C6.325 9.7915 6.04167 9.50817 6.04167 9.1665C6.04167 8.82484 6.325 8.5415 6.66667 8.5415H13.3333C13.675 8.5415 13.9583 8.82484 13.9583 9.1665C13.9583 9.50817 13.675 9.7915 13.3333 9.7915Z",
    fill: "#026C96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9582H6.66667C6.325 13.9582 6.04167 13.6748 6.04167 13.3332C6.04167 12.9915 6.325 12.7082 6.66667 12.7082H10C10.3417 12.7082 10.625 12.9915 10.625 13.3332C10.625 13.6748 10.3417 13.9582 10 13.9582Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteText);
export default __webpack_public_path__ + "static/media/note-text.58b650800bb0235754b1b22636d336c9.svg";
export { ForwardRef as ReactComponent };